<template>
  <div>
    <div class="d-flex mb-3 align-items-end">
      <h1 class="h4 primary--text">
        {{ $t('views.orders.report_list_by_parts') }}
      </h1>
      <div class="ml-auto">
        <download-excel
          url="order-reports/forecast-by-parts"
          file-name="forecast-by-parts.xlsx"
          :filters="filters"
          :params="params"
        />
        <v-btn
          outlined
          large
          @click="toggleFilters"
        >
          <v-icon left>
            mdi-filter-variant
          </v-icon>
          {{ $t('common.filter') }}
        </v-btn>
      </div>
    </div>
    <table-filters
      v-if="filtersShown"
      :filters="filters"
      :no-items-found="noItemsFound"
      @search="getItems(true)"
    />
    <div class="position-relative overflow-auto">
      <v-data-table
        class="parts-table"
        fixed-header
        :headers="headers"
        :items="items"
        :options.sync="options"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50, 100],
        }"
      />
    </div>
  </div>
</template>

<script>
import TableFilters from '@/components/common/TableFilters.vue';
import DownloadExcel from '@/components/common/DownloadExcel.vue';

export default {
  name: 'ReportListByParts',
  components: {
    TableFilters,
    DownloadExcel,
  },
  data() {
    return {
      total: 0,
      items: [],
      loading: true,
      options: {
        page: 1,
      },
      headers: [],
      noItemsFound: false,
      headersFixed: [],
      filtersShown: true,
      filters: [{
        label: this.$t('common.supplier'),
        key: 'supplier',
        value: '',
        requiredForSupplier: true,
      }, {
        label: this.$t('common.plant'),
        key: 'plant',
        value: '',
        requiredForSupplier: true,
      }, {
        label: this.$t('common.part'),
        key: 'part',
        value: '',
      }],
    };
  },
  computed: {
    params() {
      const {
        sortBy, sortDesc, page, itemsPerPage,
      } = this.options;

      const params = this.filters.reduce((acc, it) => {
        if (it.value) {
          acc[it.key] = it.value;
        }
        return acc;
      }, {});

      if (itemsPerPage !== -1) {
        params.pageSize = itemsPerPage;
        params.page = page;
      }

      if (sortBy && sortBy.length) {
        params.sort = `${sortDesc[0] ? '-' : ''}${sortBy[0]}`;
      }

      return params;
    },
  },
  watch: {
    options: {
      handler() {
        this.getItems();
      },
      deep: true,
    },
  },
  methods: {
    async getItems(filtered) {
      if (filtered) {
        this.options.page = 1;
      }

      try {
        const { data = {} } = await this.$http.get('order-reports/forecast-by-parts', { params: this.params });

        if ((data.items || []).length) {
          this.noItemsFound = false;
          this.headers = data.headers;
          this.items = data.items;
          this.total = data.total;
        } else {
          this.items = [];
          this.noItemsFound = true;
        }
      } catch (err) {
        this.$http.mockApiError(err);
      } finally {
        this.loading = false;
      }
    },
    toggleFilters() {
      this.filtersShown = !this.filtersShown;
    },
  },
};
</script>

<style lang="scss">
.parts-table {

  & th:first-child,
  & td:first-child {
    position: sticky;
    left: 0;
    min-width: 180px;
    z-index: 3;
    background: white;
  }

  & th:nth-child(2),
  & td:nth-child(2) {
    position: sticky;
    left: 180px;
    z-index: 4;
    background: white;
    box-shadow: inset -4px 0 5px -2px rgba(0,0,0,.16078);
  }

  & th:nth-child(2) {
    box-shadow:
      inset 0 -1px 0 rgba(0, 0, 0, 0.12),
      inset -4px 0 5px -2px rgba(0, 0, 0, 0.16078) !important;
  }

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: #fff;
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--amber);
    border-radius: 10px;
  }
}
</style>
